import $axios from './api';

export const create = async (marathon) => {

	const { data } = await $axios.post('/v1/author/marathon/create', marathon);
	return data;
};

export const list = async () => {

	// const { data } = await $axios.post('/v1/author/marathon/list', { limit, page, sortBy, sortDirection });
	const { data } = await $axios.post('/v1/author/marathon/list', {});
	return data;

};

export const getById = async (id) => {

	const { data } = await $axios.get(`/v1/author/marathon/${id}`);
	return data;

};

export const update = async (id, payload) => {

	const { data } = await $axios.post(`/v1/author/marathon/${id}`, payload);
	return data;
	
};

export const cancel = async (id) => {

	const { data } = await $axios.post(`/v1/author/marathon/${id}/cancel`);
	return data;

};